<template>
  <div class="progress-steps">
    <ul class="progress-steps-list">
      <li
        v-for="(step, index) in steps.filter((s) => s.visible !== true)"
        :key="index"
        class="progress-step"
        :class="[
          {
            'progress-step--active': progressStep === step.order,
            'progress-step--completed': progressStep > step.order,
          },
          { 'progress-step--completed': step.checkingVerification },
        ]"
      >
        <span class="progress-step-circle" />
        {{ step.name }}
      </li>
    </ul>
  </div>
</template>

<script>
import { registrationConfig } from "@/helpers/config";
import { useMemberDetails } from "@/helpers/member-details";
import { studentCodes } from "@/helpers/membership";
import { useProgressHelper } from "@/helpers/progress-helper";
import { computed } from "@vue/composition-api";

export default {
  props: ["step"],
  setup(_, ctx) {
    const { isActivating, membershipStatusType } = useMemberDetails();
    const { overseasMembershipCodes } = registrationConfig;

    const steps = computed(() => [
      {
        order: 0,
        name: "Account set up",
      },
      {
        order: 1,
        name: "Email verification",
        checkingVerification: ctx.root.$route.name === "CheckVerification",
      },
      {
        order: 2,
        name: "About you",
      },
      {
        order: 3,
        name: "Work information",
        visible: ["RET", ...studentCodes, ...overseasMembershipCodes].includes(
          membershipStatusType.value,
        ),
      },
      {
        order: 4,
        name: "Education",
        visible: ["RET", "RAS"].includes(membershipStatusType.value),
      },
      {
        order: 5,
        name: "Diversity",
      },
      {
        order: 6,
        name: "Confirm Details",
      },
      {
        order: 7,
        name: "Payment",
        visible: isActivating.value,
      },
    ]);

    const { progressStep } = useProgressHelper();
    const activeSteps = steps.value.filter((s) => {
      return s.visible !== false;
    }).length;
    const percentWidth = `${100 / activeSteps}%`;

    return {
      steps,
      percentWidth,
      progressStep,
      activeSteps,
      isActivating,
    };
  },
};
</script>

<style lang="scss" scoped>
.progress-steps {
  &-list {
    list-style: none;
    margin: 0;
    padding: 0;

    .progress-step {
      align-items: center;
      color: var(--mid-grey);
      display: flex;
      font-size: 10px;
      font-weight: 700;
      line-height: 28px;
      margin-bottom: 2.4em;
      position: relative;

      &--active {
        color: var(--body);

        .progress-step-circle {
          border-color: var(--green);
        }
      }

      &--completed {
        color: var(--green);
        font-size: 14px;
        margin-bottom: 1.7em;

        .progress-step-circle {
          position: relative;
          border-color: var(--green);
          background-color: var(--green);

          &:after {
            content: "";
            background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAYAAAA1WQxeAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABHSURBVHgBfY5RDQAgCESJYAQiGMEoNrCKjYxgBKPgufmB2yHb++Fx7ESCMbMkH6lg0CMnlb4F85F32ZzMLNnBAjUqddKFuQ2/oEJvCeCMbgAAAABJRU5ErkJggg==");
            background-repeat: no-repeat;
            height: 7px;
            left: 50%;
            position: absolute;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 8px;
          }
        }
      }

      &-circle {
        border: 1px solid var(--mid-grey);
        border-radius: 500px;
        height: 17px;
        margin-right: 8px;
        width: 17px;
      }
    }
  }
}
</style>
